import { useEffect, useState } from 'react';

/**
 * Custom hook to initialize Meta Pixel based on admin settings
 * Fetches CAPI settings and initializes the pixel if enabled
 */
export const useMetaPixel = () => {
  const [pixelInitialized, setPixelInitialized] = useState(false);
  const [pixelId, setPixelId] = useState(null);

  useEffect(() => {
    const initializePixel = async () => {
      try {
        const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
        
        // Fetch public settings (this endpoint should be created to expose meta pixel settings safely)
        const response = await fetch(`${API_BASE_URL}/api/settings/public`);
        if (!response.ok) {
          console.log('Could not fetch public settings for Meta Pixel');
          return;
        }
        
        const settings = await response.json();
        
        // Check if Meta CAPI is enabled and pixel ID is provided
        if (settings.meta_capi_enabled && settings.meta_pixel_id) {
          // Initialize the pixel using the global function from index.html
          if (window.initializeMetaPixel) {
            window.initializeMetaPixel(settings.meta_pixel_id);
            setPixelId(settings.meta_pixel_id);
            setPixelInitialized(true);
          }
        }
      } catch (error) {
        console.log('Meta Pixel initialization error:', error);
      }
    };

    // Only initialize once
    if (!pixelInitialized && !window.fbq) {
      initializePixel();
    }
  }, [pixelInitialized]);

  // Utility function to track custom events
  const trackEvent = (eventName, parameters = {}) => {
    if (window.fbq && pixelInitialized) {
      window.fbq('track', eventName, parameters);
    }
  };

  // Utility function to track custom conversions
  const trackCustomEvent = (eventName, parameters = {}) => {
    if (window.fbq && pixelInitialized) {
      window.fbq('trackCustom', eventName, parameters);
    }
  };

  return {
    pixelInitialized,
    pixelId,
    trackEvent,
    trackCustomEvent
  };
};